module.exports = __webpack_public_path__ + "img/instance1.21e5eb82.png";